import { MIN_DATE_RANGE } from '@/constants/constants';
import { parseRelativeDateSelection } from '@/pages/Markets/MarketsComponents/Chart/ForwardCurveChartBlock/CurveComparisonSelector/parseRelativeDateSelectionToIso';
import { getPrefixNumberFromString } from '@/utils/getPrefixNumberFromString';

export function parseFromToISO(from: string | undefined) {
  if (from) {
    const compareTo = getPrefixNumberFromString(from);
    if (compareTo) {
      const compareToUnit = from.slice(compareTo.length);
      const fromDate = parseRelativeDateSelection(Number(compareTo), compareToUnit);
      return fromDate.toISOString();
    }
    return MIN_DATE_RANGE;
  }
  return MIN_DATE_RANGE;
}
